import { useTranslation } from 'react-i18next';
import { PageWrapper } from '@src/components';
import { useDispatch } from 'react-redux';
import { logout } from '@src/store/user/userSlice';
import { Button } from 'antd';
import { useLogoutUserMutation } from '@src/services/user/userApiSlice';
import { useNavigate } from 'react-router-dom';

interface LogoutProps {
  onClose: () => void;
}
export function Logout({ onClose }: Readonly<LogoutProps>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();

  const handleLogOut = async () => {
    try {
      await logoutUser().unwrap();
    } catch (e) {
      // Ignore error and force local logout anyway
    } finally {
      dispatch(logout(undefined));
      onClose();
      navigate('/');
    }
  };

  return (
    <>
      <PageWrapper rootClassName='p-4 bg-wl-background space-y-2 mt-4'>
        <p className='font-bold text-wl-on-background'>
          {t('pages.auth.signOut.areYouSure')}
        </p>
        <p className='text-wl-on-background'>
          {t('pages.auth.signOut.description')}
        </p>
      </PageWrapper>
      <div className='flex justify-between gap-4 mt-8'>
        <Button onClick={onClose} className='btn-secondary w-1/2'>
          {t('buttons.cancel')}
        </Button>
        <Button
          htmlType='button'
          className='btn-danger w-1/2'
          onClick={handleLogOut}
          loading={isLoading}
        >
          {t('buttons.signOut')}
        </Button>
      </div>
    </>
  );
}
